import React, { useState } from 'react';
import Potion from './images/LevelingPotion.png';
import Trophy from './images/Icon_Trophy.png';
import Time from './images/Icon_Time.png';
import expstar from './images/Icon_Star.png';

function InventoryLevelingpotion({ changeActiveComponent, levelingPotionBalance, nfts }) {

    return (
        <section id="inventory-purse">
        <div className="inventory-container-right">
            <div className="active-item-header-content">
                <div className="inventory-item-active item-potion"><img src={Potion} /></div>
                <div className="active-item-header"><h2>Leveling Potion</h2><p>Item</p></div>
                <div className="descrition"><p>Use leveling potion to level up your ants.</p></div>
                </div>
            <div className="active-item-stats-top" id="chestrewards"><div className="line2"></div><h2>ON USE</h2><div className="line2"></div></div>
            <div className="active-item-stats-mid"><img src={expstar}/></div><p>+1 Exp</p>
            <div className="active-item-stats"><h2 id="item-stat-quantity">QUANTITY:</h2><h2>{+levelingPotionBalance}</h2></div>
            <div className="active-item-buttons-container">
            <button className="active-item-button-upper" onClick={() => changeActiveComponent('uselevelingpotion')}>USE POTIONS</button>
            <button className="active-item-button-lower" onClick={() => changeActiveComponent('shop')}>BUY MORE</button>
            </div>
        </div>
        </section>
    );
}

export default InventoryLevelingpotion;